import ConsultaCrud from './ConsultaCrud'

export default ConsultaCrud;


// WEBPACK FOOTER //
// ./src/components/ConsultaCrud/index.js